import { render, staticRenderFns } from "./BeneficiaryList.vue?vue&type=template&id=79d90f74&"
import script from "./BeneficiaryList.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryList.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports